import IconToastError from '@/icons/toast-error.svg';

function PaymentError(props) {
	return (
		<div className="border-state-red flex items-center gap-2.5 rounded border px-3 py-2">
			<IconToastError className="text-state-red size-5" />
			<p className="text-body1 text-state-red font-semibold" {...props} />
		</div>
	);
}

export default PaymentError;
